// Element.prototype.findParent = function (loops) {
//     let parent = this;

//     for (let i = 0; i < loops; i++) {
//         parent = parent.parentElement;
//     }

//     return parent;
// }, false;

Element.prototype.getParentByClassName = function(className) {
	let parent = this.parentElement;

	while ( ! parent.classList.contains(className) && parent.tagName !== "BODY") {

		parent = parent.parentElement;
	}

	return parent.tagName !== "BODY" ? parent : false;
}, false;


Element.prototype.appendBefore = function (element) {

    element.parentNode.insertBefore(this, element);
}, false;

Element.prototype.appendAfter = function (element) {

    element.parentNode.insertBefore(this, element.nextSibling);
}, false;